import React, { useState, useEffect } from 'react';
import { signatureAPI } from '../api';

function Signatures() {
  const [signatures, setSignatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingSignature, setEditingSignature] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    content: '',
    is_default: false,
  });
  const [message, setMessage] = useState({ type: '', text: '' });
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    loadSignatures();
  }, []);

  const loadSignatures = async () => {
    try {
      const response = await signatureAPI.getAll();
      if (response.data.success) {
        setSignatures(response.data.data);
      }
    } catch (error) {
      console.error('加载签名失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingSignature) {
        await signatureAPI.update(editingSignature.id, formData);
        setMessage({ type: 'success', text: '更新成功！' });
      } else {
        await signatureAPI.create(formData);
        setMessage({ type: 'success', text: '添加成功！' });
      }
      setShowModal(false);
      setEditingSignature(null);
      setFormData({ name: '', content: '', is_default: false });
      loadSignatures();
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (error) {
      setMessage({ type: 'error', text: error.response?.data?.message || '操作失败' });
    }
  };

  const handleEdit = (signature) => {
    setEditingSignature(signature);
    setFormData({
      name: signature.name,
      content: signature.content,
      is_default: signature.is_default,
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('确定要删除这个签名吗？')) return;

    try {
      await signatureAPI.delete(id);
      setMessage({ type: 'success', text: '删除成功！' });
      loadSignatures();
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (error) {
      setMessage({ type: 'error', text: '删除失败' });
    }
  };

  // 签名模板示例
  const templates = [
    {
      name: '简单签名',
      content: `<div style="margin-top: 20px; padding-top: 15px; border-top: 1px solid #ddd; color: #666;">
  <p style="margin: 5px 0;"><strong>Ethan</strong></p>
  <p style="margin: 5px 0;">Email Marketing Team</p>
  <p style="margin: 5px 0;">📧 ethan@serenejade.com</p>
</div>`
    },
    {
      name: '完整签名',
      content: `<table style="margin-top: 20px; border-top: 2px solid #3498db; padding-top: 15px; font-family: Arial, sans-serif;">
  <tr>
    <td style="padding-right: 20px; border-right: 2px solid #ddd;">
      <p style="margin: 5px 0; font-size: 16px; font-weight: bold; color: #333;">Ethan</p>
      <p style="margin: 5px 0; font-size: 13px; color: #666;">Marketing Manager</p>
    </td>
    <td style="padding-left: 20px;">
      <p style="margin: 5px 0; font-size: 12px; color: #666;">📧 ethan@serenejade.com</p>
      <p style="margin: 5px 0; font-size: 12px; color: #666;">📱 +1 (555) 123-4567</p>
      <p style="margin: 5px 0; font-size: 12px; color: #666;">🌐 www.serenejade.com</p>
    </td>
  </tr>
</table>`
    },
    {
      name: '品牌签名',
      content: `<div style="margin-top: 20px; padding: 20px; background: #f8f9fa; border-left: 4px solid #3498db;">
  <p style="margin: 5px 0; font-size: 16px; font-weight: bold; color: #2c3e50;">Ethan</p>
  <p style="margin: 5px 0; font-size: 14px; color: #7f8c8d;">Email Marketing Specialist</p>
  <p style="margin: 10px 0 5px 0; font-size: 12px; color: #34495e;">
    📧 ethan@serenejade.com | 📱 +1 (555) 123-4567
  </p>
  <p style="margin: 5px 0; font-size: 11px; color: #95a5a6; font-style: italic;">
    "让每封邮件都有温度"
  </p>
</div>`
    }
  ];

  if (loading) {
    return <div>加载中...</div>;
  }

  return (
    <div>
      <div className="page-header">
        <h1>邮件签名管理</h1>
        <p>管理您的HTML邮件签名模板</p>
      </div>

      {message.text && (
        <div className={`alert alert-${message.type}`}>
          {message.text}
        </div>
      )}

      <div className="card">
        <div className="card-header">
          <h2>签名列表</h2>
          <button
            className="btn btn-primary"
            onClick={() => {
              setEditingSignature(null);
              setFormData({ name: '', content: '', is_default: false });
              setShowModal(true);
            }}
          >
            + 添加签名
          </button>
        </div>

        {signatures.length === 0 ? (
          <p style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
            暂无签名，请添加一个
          </p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>签名名称</th>
                <th>预览</th>
                <th>默认</th>
                <th>创建时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {signatures.map((signature) => (
                <tr key={signature.id}>
                  <td>{signature.name}</td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{ __html: signature.content }}
                      style={{
                        maxWidth: '300px',
                        overflow: 'hidden',
                        fontSize: '12px',
                        border: '1px solid #eee',
                        padding: '5px',
                        background: '#fafafa'
                      }}
                    />
                  </td>
                  <td>
                    {signature.is_default && (
                      <span className="badge badge-success">默认</span>
                    )}
                  </td>
                  <td>{new Date(signature.created_at).toLocaleDateString()}</td>
                  <td>
                    <button
                      className="btn btn-primary"
                      style={{ padding: '5px 10px', fontSize: '12px', marginRight: '5px' }}
                      onClick={() => handleEdit(signature)}
                    >
                      编辑
                    </button>
                    <button
                      className="btn btn-danger"
                      style={{ padding: '5px 10px', fontSize: '12px' }}
                      onClick={() => handleDelete(signature.id)}
                    >
                      删除
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* 签名模板 */}
      <div className="card">
        <div className="card-header">
          <h2>签名模板示例</h2>
        </div>
        <div style={{ padding: '20px' }}>
          <p style={{ marginBottom: '20px', color: '#666' }}>点击下方模板快速创建签名（可以修改后使用）</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
            {templates.map((template, index) => (
              <div key={index} style={{ border: '1px solid #ddd', borderRadius: '5px', padding: '15px' }}>
                <h3 style={{ fontSize: '16px', marginBottom: '10px' }}>{template.name}</h3>
                <div
                  dangerouslySetInnerHTML={{ __html: template.content }}
                  style={{
                    border: '1px solid #eee',
                    padding: '10px',
                    background: '#fafafa',
                    marginBottom: '10px',
                    fontSize: '13px'
                  }}
                />
                <button
                  className="btn btn-secondary"
                  style={{ width: '100%', padding: '8px', fontSize: '13px' }}
                  onClick={() => {
                    setFormData({ name: template.name, content: template.content, is_default: false });
                    setEditingSignature(null);
                    setShowModal(true);
                  }}
                >
                  使用此模板
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px' }}>
            <div className="modal-header">
              <h2>{editingSignature ? '编辑签名' : '添加签名'}</h2>
              <button className="modal-close" onClick={() => setShowModal(false)}>
                ×
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>签名名称 *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="例如: 正式签名、简短签名"
                  required
                />
              </div>

              <div className="form-group">
                <label>签名内容 (HTML格式) *</label>
                <textarea
                  value={formData.content}
                  onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                  placeholder="输入HTML格式的签名内容"
                  style={{ minHeight: '200px', fontFamily: 'monospace', fontSize: '13px' }}
                  required
                />
              </div>

              <div className="form-group">
                <label style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    checked={formData.is_default}
                    onChange={(e) => setFormData({ ...formData, is_default: e.target.checked })}
                    style={{ marginRight: '8px', width: 'auto' }}
                  />
                  <span>设为默认签名</span>
                </label>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{ marginRight: '10px' }}
                  onClick={() => setShowPreview(!showPreview)}
                >
                  {showPreview ? '隐藏预览' : '显示预览'}
                </button>
              </div>

              {showPreview && (
                <div style={{ marginBottom: '20px' }}>
                  <h3 style={{ fontSize: '16px', marginBottom: '10px' }}>预览效果：</h3>
                  <div
                    dangerouslySetInnerHTML={{ __html: formData.content }}
                    style={{
                      border: '2px solid #3498db',
                      padding: '20px',
                      background: '#fff',
                      borderRadius: '5px'
                    }}
                  />
                </div>
              )}

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  取消
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingSignature ? '更新' : '添加'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Signatures;

